import { useState, useEffect } from 'react'

export interface UseShowTourArgs {
  isActive: boolean
  onComplete: () => void
}

export interface UseShowTourHandler {
  active: boolean
  hide: () => void
}

export const useShowTour = ({
  isActive,
  onComplete,
}: UseShowTourArgs): UseShowTourHandler => {
  const [shouldShowTour, setShouldShowTour] = useState(isActive)
  const [isTourComplete, setIsTourComplete] = useState(false)

  const handleCompleteTour = () => {
    setShouldShowTour(false)
    setIsTourComplete(true)
    onComplete()
  }

  // toggle show state
  useEffect(() => {
    if (!isTourComplete) {
      setShouldShowTour(isActive)
    }
  }, [isActive, isTourComplete])

  return {
    active: shouldShowTour,
    hide: handleCompleteTour,
  }
}
